import React from 'react';

const TreasurySplashScreenImage = () => {
    return (
        <svg
            width='142'
            height='98'
            viewBox='0 0 142 98'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g clipPath='url(#clip0_10736_46760)'>
                <path
                    d='M28.4468 1.68945H133.661C137.449 1.68968 140.311 4.52202 140.311 7.7666V82.3291C140.311 85.5735 137.449 88.405 133.661 88.4053H28.4468C24.6586 88.4051 21.7966 85.5735 21.7964 82.3291V7.7666C21.7964 4.52201 24.6585 1.68966 28.4468 1.68945Z'
                    fill='#E5F3F7'
                    stroke='#0088B2'
                    strokeWidth='3.37931'
                />
                <path
                    d='M33.0176 7.70886H128.482C130.757 7.70886 132.602 9.55342 132.602 11.828V77.7245C132.601 79.9989 130.757 81.8427 128.482 81.8427H33.0176C30.7431 81.8427 28.8987 79.9989 28.8984 77.7245V11.828C28.8984 9.55342 30.743 7.70886 33.0176 7.70886Z'
                    fill='white'
                    stroke='#0088B2'
                    strokeWidth='0.211273'
                />
                <path
                    d='M102.459 35.6495V61.6749H63.1511V35.6495H102.459Z'
                    fill='#DEE8F5'
                    stroke='#344054'
                    strokeWidth='0.296569'
                />
                <path
                    opacity='0.55'
                    d='M102.902 35.2269V41.6195H62.2871V35.2269H102.902Z'
                    fill='#FEF0C7'
                    stroke='#344054'
                    strokeWidth='0.296569'
                />
                <path
                    d='M109.853 63.8179V66.2505H55.7576V63.8179H109.853Z'
                    fill='#FFFAEB'
                    stroke='#344054'
                    strokeWidth='0.296569'
                />
                <path
                    d='M107.945 61.0886V63.5212H57.6658V61.0886H107.945Z'
                    fill='#FFFAEB'
                    stroke='#344054'
                    strokeWidth='0.296569'
                />
                <path
                    d='M107.945 63.0876V63.5212H57.6658V63.0876H107.945Z'
                    fill='#E5F3F7'
                    stroke='#344054'
                    strokeWidth='0.296569'
                />
                <path
                    d='M109.853 65.8169V66.2505H55.7576V65.8169H109.853Z'
                    fill='#E5F3F7'
                    stroke='#344054'
                    strokeWidth='0.296569'
                />
                <path
                    d='M111.677 66.5471V68.9797H54.0059V66.5471H111.677Z'
                    fill='#FFFAEB'
                    stroke='#344054'
                    strokeWidth='0.296569'
                />
                <path
                    d='M111.677 68.5463V68.9799H54.0059V68.5463H111.677Z'
                    fill='#E5F3F7'
                    stroke='#344054'
                    strokeWidth='0.296569'
                />
                <path
                    d='M65.5967 37.7013V59.5636H61.5166V37.7013H65.5967Z'
                    fill='#FFFAEB'
                    stroke='#344054'
                    strokeWidth='0.296569'
                />
                <path
                    d='M76.6375 37.7013V59.5636H72.5574V37.7013H76.6375Z'
                    fill='#FFFAEB'
                    stroke='#344054'
                    strokeWidth='0.296569'
                />
                <path
                    d='M104.093 37.7013V59.5636H100.013V37.7013H104.093Z'
                    fill='#FFFAEB'
                    stroke='#344054'
                    strokeWidth='0.296569'
                />
                <path
                    d='M66.9143 35.6495V38.0157C66.9143 38.0604 66.8969 38.1032 66.8655 38.1349C66.8337 38.1666 66.7902 38.1847 66.7454 38.1847H60.3674C60.3227 38.1846 60.28 38.1666 60.2483 38.1349C60.2166 38.1032 60.1985 38.0606 60.1985 38.0157V35.6495H66.9143Z'
                    fill='url(#paint0_linear_10736_46760)'
                    stroke='#344054'
                    strokeWidth='0.296569'
                />
                <path
                    d='M77.9553 35.6495V38.0157C77.9553 38.0379 77.9511 38.0597 77.9426 38.0802C77.9342 38.1006 77.922 38.1193 77.9065 38.1349C77.8908 38.1506 77.8714 38.1635 77.8508 38.172C77.8304 38.1804 77.8085 38.1847 77.7864 38.1847H71.4084C71.3637 38.1846 71.321 38.1666 71.2893 38.1349C71.2577 38.1032 71.2396 38.0606 71.2395 38.0157V35.6495H77.9553Z'
                    fill='url(#paint1_linear_10736_46760)'
                    stroke='#344054'
                    strokeWidth='0.296569'
                />
                <path
                    d='M105.411 35.6495V38.0157C105.411 38.0604 105.394 38.1032 105.362 38.1349C105.331 38.1666 105.287 38.1847 105.242 38.1847H98.8643C98.8195 38.1846 98.7768 38.1666 98.7451 38.1349C98.7135 38.1032 98.6954 38.0606 98.6953 38.0157V35.6495H105.411Z'
                    fill='url(#paint2_linear_10736_46760)'
                    stroke='#344054'
                    strokeWidth='0.296569'
                />
                <path
                    d='M60.3674 59.1017H66.7454C66.7675 59.1017 66.7894 59.1059 66.8098 59.1144C66.8304 59.1229 66.8497 59.1358 66.8655 59.1515C66.881 59.1671 66.8932 59.1858 66.9016 59.2062C66.9101 59.2266 66.9143 59.2485 66.9143 59.2706V60.7911H60.1985V59.2706C60.1985 59.2485 60.2027 59.2266 60.2112 59.2062C60.2197 59.1856 60.2325 59.1672 60.2483 59.1515C60.264 59.1357 60.2824 59.1229 60.303 59.1144C60.3234 59.1059 60.3453 59.1017 60.3674 59.1017Z'
                    fill='url(#paint3_linear_10736_46760)'
                    stroke='#344054'
                    strokeWidth='0.296569'
                />
                <path
                    d='M71.4084 59.1017H77.7864C77.8085 59.1017 77.8304 59.1059 77.8508 59.1144C77.8714 59.1229 77.8908 59.1358 77.9065 59.1515C77.922 59.1671 77.9342 59.1858 77.9426 59.2062C77.9511 59.2266 77.9553 59.2485 77.9553 59.2706V60.7911H71.2395V59.2706C71.2395 59.2485 71.2437 59.2266 71.2522 59.2062C71.2607 59.1856 71.2736 59.1672 71.2893 59.1515C71.3051 59.1357 71.3234 59.1229 71.344 59.1144C71.3644 59.1059 71.3863 59.1017 71.4084 59.1017Z'
                    fill='url(#paint4_linear_10736_46760)'
                    stroke='#344054'
                    strokeWidth='0.296569'
                />
                <path
                    d='M98.8643 59.1017H105.242C105.264 59.1017 105.286 59.1059 105.307 59.1144C105.327 59.1229 105.347 59.1357 105.362 59.1515C105.378 59.1671 105.39 59.1858 105.398 59.2062C105.407 59.2266 105.411 59.2485 105.411 59.2706V60.7911H98.6953V59.2706C98.6954 59.2485 98.6996 59.2266 98.708 59.2062C98.7165 59.1856 98.7294 59.1672 98.7451 59.1515C98.7609 59.1357 98.7792 59.1229 98.7998 59.1144C98.8202 59.1059 98.8421 59.1017 98.8643 59.1017Z'
                    fill='url(#paint5_linear_10736_46760)'
                    stroke='#344054'
                    strokeWidth='0.296569'
                />
                <path
                    d='M62.7803 39.4773C62.8198 39.4775 62.8516 39.5099 62.8516 39.5496V57.7156C62.8515 57.7551 62.8198 57.7876 62.7803 57.7878C62.7406 57.7878 62.7081 57.7553 62.708 57.7156V39.5496C62.708 39.5098 62.7405 39.4773 62.7803 39.4773Z'
                    fill='url(#paint6_linear_10736_46760)'
                    stroke='#344054'
                    strokeWidth='0.296569'
                />
                <path
                    d='M64.3333 39.4773C64.3728 39.4775 64.4045 39.5099 64.4045 39.5496V57.7156C64.4045 57.7551 64.3728 57.7876 64.3333 57.7878C64.2935 57.7878 64.2611 57.7553 64.261 57.7156V39.5496C64.261 39.5098 64.2935 39.4773 64.3333 39.4773Z'
                    fill='url(#paint7_linear_10736_46760)'
                    stroke='#344054'
                    strokeWidth='0.296569'
                />
                <path
                    d='M73.8215 39.4773C73.8611 39.4775 73.8928 39.5099 73.8928 39.5496V57.7156C73.8927 57.7551 73.8611 57.7876 73.8215 57.7878C73.7818 57.7878 73.7494 57.7553 73.7493 57.7156V39.5496C73.7493 39.5098 73.7818 39.4773 73.8215 39.4773Z'
                    fill='url(#paint8_linear_10736_46760)'
                    stroke='#344054'
                    strokeWidth='0.296569'
                />
                <path
                    d='M75.3743 39.4773C75.4138 39.4775 75.4456 39.5099 75.4456 39.5496V57.7156C75.4455 57.7551 75.4138 57.7876 75.3743 57.7878C75.3346 57.7878 75.3021 57.7553 75.302 57.7156V39.5496C75.302 39.5098 75.3345 39.4773 75.3743 39.4773Z'
                    fill='url(#paint9_linear_10736_46760)'
                    stroke='#344054'
                    strokeWidth='0.296569'
                />
                <path
                    d='M93.3933 37.7013V59.5636H89.3132V37.7013H93.3933Z'
                    fill='#FFFAEB'
                    stroke='#344054'
                    strokeWidth='0.296569'
                />
                <path
                    d='M94.7109 35.6495V38.0157C94.7109 38.0604 94.6936 38.1032 94.6621 38.1349C94.6304 38.1666 94.5869 38.1847 94.542 38.1847H88.1641C88.1193 38.1846 88.0766 38.1666 88.0449 38.1349C88.0133 38.1032 87.9952 38.0606 87.9951 38.0157V35.6495H94.7109Z'
                    fill='url(#paint10_linear_10736_46760)'
                    stroke='#344054'
                    strokeWidth='0.296569'
                />
                <path
                    d='M88.1641 59.1017H94.542C94.5641 59.1017 94.586 59.1059 94.6064 59.1144C94.627 59.1229 94.6454 59.1358 94.6611 59.1515C94.6769 59.1672 94.6897 59.1856 94.6982 59.2062C94.7067 59.2266 94.7109 59.2485 94.7109 59.2706V60.7911H87.9951V59.2706C87.9952 59.2485 87.9994 59.2266 88.0078 59.2062C88.0163 59.1856 88.0292 59.1672 88.0449 59.1515C88.0607 59.1357 88.0791 59.1229 88.0996 59.1144C88.12 59.1059 88.1419 59.1017 88.1641 59.1017Z'
                    fill='url(#paint11_linear_10736_46760)'
                    stroke='#344054'
                    strokeWidth='0.296569'
                />
                <path
                    d='M90.5771 39.4773C90.6167 39.4775 90.6484 39.5099 90.6484 39.5496V57.7156C90.6484 57.7551 90.6167 57.7876 90.5771 57.7878C90.5374 57.7878 90.505 57.7553 90.5049 57.7156V39.5496C90.5049 39.5098 90.5374 39.4773 90.5771 39.4773Z'
                    fill='url(#paint12_linear_10736_46760)'
                    stroke='#344054'
                    strokeWidth='0.296569'
                />
                <path
                    d='M92.1299 39.4773C92.1694 39.4775 92.2012 39.5099 92.2012 39.5496V57.7156C92.2011 57.7551 92.1694 57.7876 92.1299 57.7878C92.0902 57.7878 92.0577 57.7553 92.0576 57.7156V39.5496C92.0576 39.5098 92.0901 39.4773 92.1299 39.4773Z'
                    fill='url(#paint13_linear_10736_46760)'
                    stroke='#344054'
                    strokeWidth='0.296569'
                />
                <path
                    d='M101.277 39.4773C101.317 39.4775 101.349 39.5099 101.349 39.5496V57.7156C101.349 57.7551 101.317 57.7876 101.277 57.7878C101.238 57.7878 101.205 57.7553 101.205 57.7156V39.5496C101.205 39.5098 101.238 39.4773 101.277 39.4773Z'
                    fill='url(#paint14_linear_10736_46760)'
                    stroke='#344054'
                    strokeWidth='0.296569'
                />
                <path
                    d='M102.83 39.4773C102.87 39.4775 102.902 39.5099 102.902 39.5496V57.7156C102.902 57.7551 102.87 57.7876 102.83 57.7878C102.791 57.7878 102.758 57.7553 102.758 57.7156V39.5496C102.758 39.5098 102.791 39.4773 102.83 39.4773Z'
                    fill='url(#paint15_linear_10736_46760)'
                    stroke='#344054'
                    strokeWidth='0.296569'
                />
                <path
                    d='M82.8049 17.7253C82.8686 17.7253 82.9309 17.7443 82.9836 17.78L107.186 34.2507C107.229 34.28 107.264 34.3201 107.288 34.366C107.312 34.4117 107.325 34.4627 107.325 34.5144V36.1267C107.325 36.1739 107.306 36.2193 107.273 36.2527C107.239 36.2861 107.194 36.3044 107.147 36.3044H58.3625C58.3152 36.3044 58.2691 36.2862 58.2356 36.2527C58.2023 36.2193 58.184 36.1738 58.1838 36.1267V34.5837C58.1838 34.5319 58.1968 34.4811 58.2209 34.4353C58.2452 34.3895 58.2796 34.3493 58.3225 34.3201H58.3235L82.6252 17.78C82.6781 17.7441 82.741 17.7253 82.8049 17.7253Z'
                    fill='#DEE8F5'
                    stroke='#344054'
                    strokeWidth='0.296569'
                />
                <path
                    d='M100.886 33.5851H64.7239L82.8049 21.2784L100.886 33.5851Z'
                    fill='#FFFAEB'
                    stroke='#344054'
                    strokeWidth='0.296569'
                />
                <path
                    d='M58.9944 51.8979C61.2428 51.898 63.0344 53.6073 63.0344 55.6616V59.4663C63.0323 59.5991 62.9777 59.7257 62.8831 59.8188C62.7885 59.9119 62.6613 59.9642 62.5286 59.9644C62.3957 59.9644 62.2678 59.912 62.1731 59.8188C62.0784 59.7257 62.0239 59.5991 62.0217 59.4663V55.6616C62.0217 54.1109 60.6286 52.9098 58.9944 52.9097C57.3601 52.9097 55.967 54.1106 55.967 55.6616V59.7534L55.9563 59.8521C55.9368 59.9493 55.8897 60.0397 55.8186 60.1108C55.7237 60.2057 55.5944 60.2593 55.4602 60.2593C55.3938 60.2593 55.3282 60.2456 55.2668 60.2202C55.2055 60.1948 55.1497 60.1578 55.1028 60.1108C55.0558 60.0638 55.0179 60.0082 54.9924 59.9468C54.967 59.8854 54.9543 59.8189 54.9543 59.7524V55.6616C54.9543 53.6072 56.7459 51.8979 58.9944 51.8979Z'
                    fill='url(#paint16_linear_10736_46760)'
                    stroke='black'
                    strokeWidth='0.677627'
                />
                <path
                    opacity='0.1'
                    d='M58.9944 51.8979C61.2428 51.898 63.0344 53.6073 63.0344 55.6616V59.4663C63.0323 59.5991 62.9777 59.7257 62.8831 59.8188C62.7885 59.9119 62.6613 59.9642 62.5286 59.9644C62.3957 59.9644 62.2678 59.912 62.1731 59.8188C62.0784 59.7257 62.0239 59.5991 62.0217 59.4663V55.6616C62.0217 54.1109 60.6286 52.9098 58.9944 52.9097C57.3601 52.9097 55.967 54.1106 55.967 55.6616V59.7534L55.9563 59.8521C55.9368 59.9493 55.8897 60.0397 55.8186 60.1108C55.7237 60.2057 55.5944 60.2593 55.4602 60.2593C55.3938 60.2593 55.3282 60.2456 55.2668 60.2202C55.2055 60.1948 55.1497 60.1578 55.1028 60.1108C55.0558 60.0638 55.0179 60.0082 54.9924 59.9468C54.967 59.8854 54.9543 59.8189 54.9543 59.7524V55.6616C54.9543 53.6072 56.7459 51.8979 58.9944 51.8979Z'
                    fill='#0F1011'
                    stroke='black'
                    strokeWidth='0.677627'
                />
                <path
                    d='M52.54 58.4749H65.4482C66.0139 58.4749 66.4727 58.9336 66.4727 59.4993V68.9446C66.4727 69.5103 66.0139 69.969 65.4482 69.969H52.54C51.9744 69.969 51.5156 69.5103 51.5156 68.9446V59.4993C51.5156 58.9336 51.9744 58.4749 52.54 58.4749Z'
                    fill='url(#paint17_linear_10736_46760)'
                    stroke='black'
                    strokeWidth='0.677627'
                />
                <path
                    d='M58.7708 63.5563L58.5803 63.4635C58.4205 63.3858 58.2859 63.2645 58.1917 63.1139C58.0974 62.9633 58.0472 62.7895 58.0471 62.6119C58.0472 62.443 58.0922 62.277 58.178 62.1315C58.2638 61.9859 58.3875 61.8656 58.5354 61.7838C58.6831 61.7021 58.85 61.6611 59.0188 61.6656C59.1876 61.6702 59.3522 61.7206 59.4954 61.8102C59.6386 61.8999 59.7554 62.0264 59.8333 62.1764C59.911 62.3263 59.9478 62.4941 59.9387 62.6627C59.9296 62.8314 59.8749 62.9947 59.7815 63.1354C59.688 63.2761 59.5585 63.3897 59.4065 63.4635L59.2151 63.5563V65.7428C59.2151 65.8017 59.1922 65.8583 59.1506 65.9C59.109 65.9417 59.0523 65.9654 58.9934 65.9655C58.9345 65.9655 58.8779 65.9417 58.8362 65.9C58.7945 65.8583 58.7708 65.8018 58.7708 65.7428V63.5563Z'
                    fill='url(#paint18_linear_10736_46760)'
                    stroke='black'
                    strokeWidth='0.677627'
                />
                <path
                    opacity='0.1'
                    d='M58.7708 63.5563L58.5803 63.4635C58.4205 63.3858 58.2859 63.2645 58.1917 63.1139C58.0974 62.9633 58.0472 62.7895 58.0471 62.6119C58.0472 62.443 58.0922 62.277 58.178 62.1315C58.2638 61.9859 58.3875 61.8656 58.5354 61.7838C58.6831 61.7021 58.85 61.6611 59.0188 61.6656C59.1876 61.6702 59.3522 61.7206 59.4954 61.8102C59.6386 61.8999 59.7554 62.0264 59.8333 62.1764C59.911 62.3263 59.9478 62.4941 59.9387 62.6627C59.9296 62.8314 59.8749 62.9947 59.7815 63.1354C59.688 63.2761 59.5585 63.3897 59.4065 63.4635L59.2151 63.5563V65.7428C59.2151 65.8017 59.1922 65.8583 59.1506 65.9C59.109 65.9417 59.0523 65.9654 58.9934 65.9655C58.9345 65.9655 58.8779 65.9417 58.8362 65.9C58.7945 65.8583 58.7708 65.8018 58.7708 65.7428V63.5563Z'
                    fill='#0F1011'
                    stroke='black'
                    strokeWidth='0.677627'
                />
                <path
                    d='M36.4282 95.8669H13.7866C12.1236 95.8669 10.7632 94.4272 10.7632 92.6354L10.7632 40.4284C10.7632 38.6366 12.1236 37.197 13.7866 37.197H36.4282C38.0913 37.197 39.4517 38.6366 39.4517 40.4284L39.4517 92.6354C39.4517 94.4272 38.0913 95.8669 36.4282 95.8669Z'
                    fill='white'
                    stroke='#344054'
                    strokeWidth='0.23158'
                />
                <path
                    d='M13.7866 36.4419H36.4282C37.4151 36.4431 38.3627 36.8613 39.063 37.6079C39.7635 38.3548 40.1595 39.369 40.1606 40.4282V92.6353C40.1595 93.6945 39.7635 94.7087 39.063 95.4556C38.3627 96.2021 37.4151 96.6204 36.4282 96.6216H13.7866C12.7998 96.6203 11.8521 96.2021 11.1519 95.4556C10.4951 94.7554 10.107 93.8204 10.0601 92.8335L10.0552 92.6353V40.4282C10.0563 39.369 10.4514 38.3548 11.1519 37.6079C11.8521 36.8614 12.7998 36.4432 13.7866 36.4419ZM13.7866 37.7202C13.1089 37.721 12.4607 38.0087 11.9839 38.5171C11.5073 39.0252 11.2405 39.7126 11.2397 40.4282V92.6353C11.2404 93.3509 11.5064 94.0392 11.9829 94.5474C12.4597 95.0558 13.1088 95.3434 13.7866 95.3442H36.4282C37.1059 95.3434 37.7542 95.0556 38.231 94.5474C38.7075 94.0393 38.9743 93.3518 38.9751 92.6362V40.4282C38.9743 39.7126 38.7075 39.0252 38.231 38.5171C37.7541 38.0088 37.1059 37.721 36.4282 37.7202H13.7866Z'
                    fill='#99CFE0'
                    stroke='#344054'
                    strokeWidth='0.23158'
                />
                <path
                    d='M29.7834 40.5507H22.7483C22.3996 40.5507 22.0627 40.403 21.8137 40.1376C21.5648 39.8719 21.4241 39.5103 21.4241 39.1317V37.1962H31.1067V39.1317C31.1067 39.5103 30.966 39.8719 30.717 40.1376C30.4682 40.4029 30.132 40.5505 29.7834 40.5507Z'
                    fill='#99CFE0'
                    stroke='#344054'
                    strokeWidth='0.23158'
                />
                <path
                    d='M24.8625 56.7583C29.4941 56.7583 33.2492 60.5125 33.2493 65.144C33.2493 69.7757 29.4942 73.5308 24.8625 73.5308C20.231 73.5307 16.4768 69.7756 16.4768 65.144C16.4769 60.5126 20.2311 56.7584 24.8625 56.7583Z'
                    fill='#FFFAEB'
                    stroke='#006C8E'
                    strokeWidth='0.569596'
                />
                <g clipPath='url(#clip1_10736_46760)'>
                    <path
                        d='M21.4291 63.5855C21.7344 63.8527 22.1047 64.0353 22.5029 64.115L24.8758 64.6005L25.9711 62.2946L26.3748 61.4451L26.419 61.3524L21.2194 60.2881C20.3171 61.3095 20.5118 62.7796 21.4291 63.5855Z'
                        fill='#FFCC00'
                    />
                    <path
                        d='M24.876 64.5995L25.9835 64.8256L28.2939 65.2977L28.4078 65.3208L28.672 64.7658C28.8793 64.3327 28.9467 63.8462 28.8649 63.3734C28.7832 62.9005 28.5563 62.4646 28.2155 62.1257L28.2131 62.1225L28.1725 62.0821L28.132 62.0416C28.1206 62.0303 28.1081 62.0189 28.0959 62.0084L28.0525 61.9708C28.0261 61.9494 27.9985 61.9275 27.9713 61.9065C27.9531 61.8923 27.9344 61.8786 27.9153 61.866C27.6452 61.6706 27.3362 61.5351 27.0091 61.4688L26.4184 61.3474L26.3742 61.4401L25.9705 62.2896L24.876 64.5995Z'
                        fill='#0088B2'
                    />
                    <path
                        d='M26.1404 70.0929L28.4078 65.3214L28.2938 65.2983L25.9834 64.8262L24.8759 64.6001L23.8443 66.7704C23.0763 68.3894 24.3498 70.2313 26.1404 70.0929Z'
                        fill='#00BAFF'
                    />
                </g>
                <path
                    d='M7.38745 60.2806C7.37031 60.4443 7.35413 60.6695 7.35913 60.9135C7.36412 61.1569 7.39012 61.4234 7.45874 61.6683C7.50332 61.8274 7.57018 61.9793 7.66089 62.1127L5.75757 62.1752C5.80045 62.1221 5.84599 62.0582 5.89038 61.9808C6.06992 61.6678 6.23801 61.1442 6.25073 60.2787L7.4021 60.1615C7.39764 60.1963 7.39211 60.2362 7.38745 60.2806Z'
                    fill='#E98862'
                    stroke='black'
                    strokeWidth='0.23158'
                />
                <path
                    d='M7.01318 56.6536C7.33103 56.6014 7.6566 56.6041 7.93994 56.6624C8.22466 56.721 8.45602 56.8329 8.59912 56.9895C8.74069 57.1446 8.86191 57.4682 8.93213 57.8899C9.00126 58.3051 9.01758 58.7942 8.96729 59.261C8.9168 59.7293 8.8004 60.1655 8.61084 60.4807C8.42298 60.793 8.17188 60.9757 7.84521 60.9758H7.84131C7.28859 60.9909 6.74016 60.8706 6.24463 60.6252L6.24268 60.6243L6.16553 60.5842C5.79391 60.3684 5.57516 59.9003 5.52979 59.3958C5.48226 58.868 5.47761 58.1076 5.6499 57.5647C5.80336 57.0815 6.36722 56.7597 7.01318 56.6536Z'
                    fill='#E98862'
                    stroke='black'
                    strokeWidth='0.23158'
                />
                <path
                    d='M5.104 56.135C5.26701 56.1132 5.43301 56.1289 5.58936 56.1799C5.74562 56.2309 5.88858 56.3163 6.00732 56.4299L6.06689 56.4875L6.14111 56.4495C6.30928 56.3622 6.49012 56.3014 6.67725 56.2717L6.67822 56.2727C7.34249 56.1803 7.83671 56.2622 8.20557 56.429C8.5742 56.5957 8.82605 56.8508 8.99854 57.1194C9.17161 57.3889 9.26532 57.6716 9.31494 57.8879C9.33855 57.9909 9.35116 58.0783 9.35889 58.1409C9.06756 58.1819 8.77329 58.2031 8.479 58.2004L8.38721 58.1995L8.36572 58.2893C8.22314 58.9005 8.08269 59.3957 7.93213 59.7864C7.7812 60.178 7.62279 60.4579 7.44873 60.6448C7.27747 60.8287 7.08966 60.9231 6.87158 60.9465C6.64921 60.9703 6.38435 60.9218 6.06006 60.7961C5.93529 60.7477 5.6851 60.5529 5.45459 60.1633C5.22676 59.7783 5.0239 59.2102 4.98682 58.4299L4.98584 58.428L4.98486 58.3694L4.98291 58.2883L4.90576 58.262L4.7915 58.217C4.68007 58.1658 4.57751 58.0965 4.48877 58.011C4.37039 57.8968 4.27937 57.757 4.22217 57.6028C4.16502 57.4488 4.14253 57.2839 4.15771 57.1204C4.17298 56.9567 4.22544 56.7983 4.31006 56.6575C4.39479 56.5165 4.5105 56.3962 4.64795 56.3059C4.78536 56.2157 4.94107 56.1568 5.104 56.135Z'
                    fill='#0F1011'
                    stroke='black'
                    strokeWidth='0.23158'
                />
                <path
                    d='M8.06445 59.15C8.23138 59.1585 8.33116 59.2098 8.39062 59.275C8.43591 59.3247 8.46634 59.3912 8.47852 59.4752L8.48438 59.566C8.48248 59.6747 8.4387 59.7787 8.36133 59.8551C8.28349 59.9319 8.17773 59.9742 8.06836 59.9742C7.95917 59.9741 7.85409 59.9318 7.77637 59.8551C7.69853 59.7783 7.65472 59.6735 7.65332 59.5641V59.5631L7.66016 59.4821C7.66512 59.4555 7.67243 59.4291 7.68262 59.4039C7.70309 59.3534 7.73388 59.3077 7.77246 59.2692C7.81105 59.2306 7.85665 59.1998 7.90723 59.1793C7.95712 59.1592 8.01066 59.1494 8.06445 59.15Z'
                    fill='#E98862'
                    stroke='black'
                    strokeWidth='0.23158'
                />
                <path
                    d='M3.83911 95.3484C3.83864 95.5448 3.83736 95.9382 3.83618 96.3192C3.83542 96.5648 3.8348 96.8052 3.83423 96.9842C3.834 97.0553 3.83341 97.1167 3.83325 97.1649L2.24731 97.16C2.24747 97.112 2.24807 97.051 2.24829 96.9803C2.24886 96.8017 2.24949 96.5612 2.25024 96.3162C2.25142 95.9368 2.2527 95.5446 2.25317 95.3484H3.83911Z'
                    fill='#E98862'
                    stroke='black'
                    strokeWidth='0.23158'
                />
                <path
                    d='M4.05054 96.689C4.07673 96.6861 4.10362 96.6886 4.12866 96.6968L6.2439 97.4058C6.28513 97.422 6.32169 97.4485 6.34839 97.4839C6.37586 97.5204 6.3917 97.5644 6.39526 97.6099C6.39782 97.6426 6.39418 97.6756 6.38354 97.7066C6.37279 97.7377 6.35502 97.7664 6.33276 97.7906C6.31048 97.8148 6.28375 97.8349 6.25366 97.8482C6.22359 97.8615 6.19083 97.8685 6.15796 97.8687L2.17456 97.8843C2.15928 97.8844 2.14376 97.8813 2.12964 97.8755C2.11561 97.8698 2.10329 97.8609 2.09253 97.8502C2.08177 97.8394 2.07299 97.8271 2.06714 97.813C2.06128 97.7989 2.05834 97.7834 2.05835 97.7681V96.7339C2.05834 96.7307 2.05864 96.727 2.0603 96.7242C2.06209 96.7213 2.06508 96.7188 2.06812 96.7173C2.07113 96.7159 2.07459 96.715 2.07788 96.7154C2.08126 96.7158 2.085 96.7171 2.08765 96.7193L2.09253 96.7232C2.3333 96.8986 2.61867 97.0028 2.91577 97.024V97.025H2.92065C3.29767 97.0363 3.66787 96.9256 3.97827 96.7115C4.00025 96.6987 4.02527 96.6919 4.05054 96.689Z'
                    fill='#C1D8ED'
                    stroke='black'
                    strokeWidth='0.23158'
                />
                <path
                    d='M11.2581 95.3478C11.246 95.511 11.2096 95.9084 11.0881 96.9348L9.51392 96.7473C9.57688 96.2133 9.64134 95.6203 9.66724 95.3478H11.2581Z'
                    fill='#E98862'
                    stroke='black'
                    strokeWidth='0.23158'
                />
                <path
                    d='M9.73706 71.7355L9.79175 72.1036L9.81128 72.2355L9.83862 72.2267C10.2116 74.2314 10.4806 76.3376 10.7322 78.4503C10.9882 80.5999 11.2268 82.7573 11.5388 84.8156H11.5398C11.5834 88.5916 11.5959 92.5492 11.741 96.3224L8.77417 96.3712C8.78203 92.6901 8.69189 88.8441 8.58374 85.1573V85.1486L8.58179 85.1398C8.03713 82.1769 7.60765 79.0556 6.97925 76.0548L6.75073 76.0675C6.20523 82.2076 5.32748 90.6323 4.74878 96.5314L1.78491 96.2804C1.98188 93.2622 2.37462 87.0588 2.71948 81.5802C2.89412 78.806 3.05671 76.2172 3.17554 74.3224C3.23495 73.375 3.28349 72.6008 3.31714 72.0636C3.33396 71.7951 3.3473 71.5857 3.3562 71.4435C3.35866 71.4041 3.36025 71.3698 3.36206 71.3409L9.73706 71.7355Z'
                    fill='#262626'
                    stroke='black'
                    strokeWidth='0.23158'
                />
                <path
                    d='M11.2976 96.689C11.3238 96.6861 11.3507 96.6886 11.3757 96.6968L13.491 97.4058C13.5322 97.422 13.5687 97.4486 13.5955 97.4839C13.6229 97.5204 13.6387 97.5644 13.6423 97.6099C13.6449 97.6426 13.6413 97.6756 13.6306 97.7066C13.6199 97.7377 13.6021 97.7664 13.5798 97.7906C13.5575 97.8148 13.5308 97.8349 13.5007 97.8482C13.4707 97.8615 13.4379 97.8685 13.405 97.8687L9.42163 97.8843C9.40636 97.8844 9.39084 97.8814 9.37671 97.8755C9.36269 97.8698 9.35035 97.8609 9.3396 97.8502C9.32885 97.8395 9.32007 97.827 9.31421 97.813C9.30835 97.7989 9.30542 97.7834 9.30542 97.7681V96.7339C9.30541 96.7307 9.30568 96.727 9.30737 96.7242C9.30917 96.7213 9.31216 96.7188 9.31519 96.7173C9.31816 96.7159 9.32165 96.7151 9.32495 96.7154C9.32833 96.7158 9.33207 96.7172 9.33472 96.7193L9.3396 96.7232C9.58035 96.8985 9.86577 97.0028 10.1628 97.024V97.025H10.1677C10.5447 97.0364 10.915 96.9257 11.2253 96.7115C11.2473 96.6987 11.2723 96.6919 11.2976 96.689Z'
                    fill='#C1D8ED'
                    stroke='black'
                    strokeWidth='0.23158'
                />
                <path
                    d='M1.68164 75.3347C1.68514 75.3919 1.68891 75.4586 1.69434 75.5271C1.70368 75.6452 1.71356 75.776 1.7168 75.9001C1.72007 76.0259 1.71676 76.1377 1.70117 76.2185C1.69925 76.2285 1.69349 76.2366 1.69141 76.2449C1.68993 76.242 1.68805 76.2392 1.68652 76.2361C1.65009 76.162 1.61487 76.0601 1.58691 75.9685L1.51074 75.7185L1.37695 75.9431C1.25554 76.1477 1.17813 76.4799 1.12695 76.8074C1.07494 77.1403 1.04691 77.4884 1.03223 77.738C1.0316 77.7475 1.02828 77.7569 1.02246 77.7644C1.01671 77.7717 1.00882 77.7771 1 77.78C0.990998 77.7829 0.980774 77.7836 0.97168 77.781C0.962617 77.7783 0.954281 77.7726 0.948242 77.7654C0.571493 77.3035 0.541648 76.6589 0.617188 76.1082C0.654562 75.8359 0.716505 75.5933 0.769531 75.4187C0.794122 75.3377 0.816999 75.2717 0.833984 75.2244L1.68164 75.3347Z'
                    fill='#E98862'
                    stroke='black'
                    strokeWidth='0.23158'
                />
                <path
                    d='M5.07568 62.0237C6.31921 62.0237 8.01086 62.0255 8.35498 62.0403C9.04922 62.07 9.47243 62.2882 9.73096 62.6155C9.99343 62.9481 10.1029 63.4139 10.1226 63.9709C10.1422 64.5268 10.0731 65.1558 9.99561 65.803C9.91858 66.4462 9.8328 67.1075 9.82568 67.7151C9.80892 69.1326 9.99223 69.9779 10.1323 70.5745C10.2735 71.1755 10.3555 71.4816 10.187 71.8694C10.1771 71.892 10.1494 71.9275 10.0854 71.97C10.0232 72.0113 9.93686 72.0536 9.82666 72.095C9.60639 72.1777 9.30558 72.2519 8.94873 72.3147C8.23597 72.44 7.31496 72.5151 6.40088 72.5188C5.48581 72.5225 4.58427 72.4549 3.90967 72.2971C3.57176 72.218 3.29875 72.1176 3.10986 71.9983C2.92048 71.8787 2.83319 71.7521 2.82471 71.6213C2.79642 71.1857 2.97364 70.7783 3.17627 70.218C3.37624 69.665 3.58736 68.992 3.5874 68.0637C3.5874 67.5931 3.47947 67.094 3.34326 66.5969C3.20452 66.0906 3.04199 65.603 2.91748 65.1116C2.67014 64.1352 2.60998 63.2739 3.24268 62.6409C3.61007 62.2734 4.26217 62.0237 5.07568 62.0237Z'
                    fill='url(#paint19_linear_10736_46760)'
                    stroke='black'
                    strokeWidth='0.23158'
                />
                <path
                    d='M4.53296 63.6907L2.69312 68.8293L2.68823 68.842L2.68628 68.8557L1.98511 75.3987L0.3396 75.2219L1.05249 68.5676C1.0594 68.5024 1.07428 68.4379 1.09644 68.3762L2.97534 63.1331L4.53296 63.6907Z'
                    fill='url(#paint20_linear_10736_46760)'
                    stroke='black'
                    strokeWidth='0.23158'
                />
                <path
                    d='M19.429 64.7092C19.3381 64.7771 19.2024 64.8537 19.0569 64.927C18.9127 64.9996 18.7643 65.0667 18.6516 65.1155C18.5954 65.1398 18.5479 65.1595 18.5149 65.1731C18.4986 65.1798 18.4855 65.1852 18.4768 65.1887C18.4725 65.1905 18.4692 65.1917 18.467 65.1926L18.4641 65.1936L18.344 65.2415L18.4045 65.3557V65.3567L18.4055 65.3577C18.4062 65.359 18.4071 65.361 18.4084 65.3635C18.4113 65.369 18.4158 65.3774 18.4211 65.3879C18.4319 65.4093 18.4472 65.4408 18.4651 65.4788C18.5009 65.5549 18.5462 65.6583 18.5862 65.7678C18.6265 65.8784 18.6593 65.9909 18.6721 66.0862C18.6858 66.1883 18.6728 66.24 18.6584 66.259C18.6492 66.2711 18.6245 66.2924 18.5774 66.3215C18.5324 66.3493 18.4743 66.3797 18.4065 66.4104C18.271 66.4717 18.1043 66.5329 17.9407 66.5881C17.7775 66.6432 17.6196 66.6916 17.5022 66.7258C17.4687 66.7356 17.4383 66.7439 17.4124 66.7512L17.0647 65.7561C17.072 65.7495 17.0806 65.7432 17.0891 65.7356C17.1403 65.6895 17.2119 65.6245 17.2922 65.55C17.4523 65.4017 17.6505 65.2128 17.7971 65.0549C17.9157 64.9275 17.9907 64.8592 18.0393 64.8254C18.0308 64.8543 18.0162 64.8917 17.9924 64.9329C17.9637 64.9826 17.9291 65.0305 17.9016 65.0667C17.8882 65.0843 17.8765 65.0987 17.8684 65.1086C17.8644 65.1135 17.8617 65.1179 17.8596 65.1204C17.8586 65.1216 17.8572 65.1227 17.8567 65.1233V65.1243L17.9993 65.301L18.0032 65.2991C18.006 65.2976 18.0105 65.2951 18.0159 65.2922C18.027 65.2864 18.0431 65.2776 18.0637 65.2668C18.1057 65.245 18.1667 65.2145 18.2395 65.178C18.3852 65.1048 18.5798 65.0094 18.7786 64.9221C18.9785 64.8343 19.178 64.756 19.3333 64.7141C19.3793 64.7017 19.4194 64.6936 19.4524 64.6887C19.4449 64.6948 19.4379 64.7026 19.429 64.7092Z'
                    fill='#E98862'
                    stroke='black'
                    strokeWidth='0.23158'
                />
                <path
                    d='M13.0154 66.4796L13.0642 66.5372L13.1365 66.5157L17.1609 65.3292L17.6296 66.9171L13.0144 68.2784C12.9385 68.3009 12.8592 68.3126 12.78 68.3126C12.6596 68.3126 12.5406 68.2853 12.4314 68.2345C12.3222 68.1837 12.2249 68.1098 12.1472 68.0177L8.47534 63.6652L9.74097 62.5978L13.0154 66.4796Z'
                    fill='url(#paint21_linear_10736_46760)'
                    stroke='black'
                    strokeWidth='0.23158'
                />
            </g>
            <defs>
                <linearGradient
                    id='paint0_linear_10736_46760'
                    x1='63.5565'
                    y1='35.5011'
                    x2='63.5565'
                    y2='38.3333'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#FFCC00' />
                    <stop offset='1' stopColor='#0088B2' />
                </linearGradient>
                <linearGradient
                    id='paint1_linear_10736_46760'
                    x1='74.5975'
                    y1='35.5011'
                    x2='74.5975'
                    y2='38.3333'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#FFCC00' />
                    <stop offset='1' stopColor='#0088B2' />
                </linearGradient>
                <linearGradient
                    id='paint2_linear_10736_46760'
                    x1='102.053'
                    y1='35.5011'
                    x2='102.053'
                    y2='38.3333'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#FFCC00' />
                    <stop offset='1' stopColor='#0088B2' />
                </linearGradient>
                <linearGradient
                    id='paint3_linear_10736_46760'
                    x1='63.5565'
                    y1='58.9532'
                    x2='63.5565'
                    y2='60.9399'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#FFCC00' />
                    <stop offset='1' stopColor='#0088B2' />
                </linearGradient>
                <linearGradient
                    id='paint4_linear_10736_46760'
                    x1='74.5975'
                    y1='58.9532'
                    x2='74.5975'
                    y2='60.9399'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#FFCC00' />
                    <stop offset='1' stopColor='#0088B2' />
                </linearGradient>
                <linearGradient
                    id='paint5_linear_10736_46760'
                    x1='102.053'
                    y1='58.9532'
                    x2='102.053'
                    y2='60.9399'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#FFCC00' />
                    <stop offset='1' stopColor='#0088B2' />
                </linearGradient>
                <linearGradient
                    id='paint6_linear_10736_46760'
                    x1='62.7798'
                    y1='39.3289'
                    x2='62.7798'
                    y2='57.9357'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#FFCC00' />
                    <stop offset='1' stopColor='#0088B2' />
                </linearGradient>
                <linearGradient
                    id='paint7_linear_10736_46760'
                    x1='64.3328'
                    y1='39.3289'
                    x2='64.3328'
                    y2='57.9357'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#FFCC00' />
                    <stop offset='1' stopColor='#0088B2' />
                </linearGradient>
                <linearGradient
                    id='paint8_linear_10736_46760'
                    x1='73.8211'
                    y1='39.3289'
                    x2='73.8211'
                    y2='57.9357'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#FFCC00' />
                    <stop offset='1' stopColor='#0088B2' />
                </linearGradient>
                <linearGradient
                    id='paint9_linear_10736_46760'
                    x1='75.3738'
                    y1='39.3289'
                    x2='75.3738'
                    y2='57.9357'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#FFCC00' />
                    <stop offset='1' stopColor='#0088B2' />
                </linearGradient>
                <linearGradient
                    id='paint10_linear_10736_46760'
                    x1='91.3531'
                    y1='35.5011'
                    x2='91.3531'
                    y2='38.3333'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#FFCC00' />
                    <stop offset='1' stopColor='#0088B2' />
                </linearGradient>
                <linearGradient
                    id='paint11_linear_10736_46760'
                    x1='91.3531'
                    y1='58.9532'
                    x2='91.3531'
                    y2='60.9399'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#FFCC00' />
                    <stop offset='1' stopColor='#0088B2' />
                </linearGradient>
                <linearGradient
                    id='paint12_linear_10736_46760'
                    x1='90.5767'
                    y1='39.3289'
                    x2='90.5767'
                    y2='57.9357'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#FFCC00' />
                    <stop offset='1' stopColor='#0088B2' />
                </linearGradient>
                <linearGradient
                    id='paint13_linear_10736_46760'
                    x1='92.1295'
                    y1='39.3289'
                    x2='92.1295'
                    y2='57.9357'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#FFCC00' />
                    <stop offset='1' stopColor='#0088B2' />
                </linearGradient>
                <linearGradient
                    id='paint14_linear_10736_46760'
                    x1='101.277'
                    y1='39.3289'
                    x2='101.277'
                    y2='57.9357'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#FFCC00' />
                    <stop offset='1' stopColor='#0088B2' />
                </linearGradient>
                <linearGradient
                    id='paint15_linear_10736_46760'
                    x1='102.83'
                    y1='39.3289'
                    x2='102.83'
                    y2='57.9357'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#FFCC00' />
                    <stop offset='1' stopColor='#0088B2' />
                </linearGradient>
                <linearGradient
                    id='paint16_linear_10736_46760'
                    x1='58.9943'
                    y1='51.5591'
                    x2='58.9943'
                    y2='60.5979'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#FFCC00' />
                    <stop offset='1' stopColor='#0088B2' />
                </linearGradient>
                <linearGradient
                    id='paint17_linear_10736_46760'
                    x1='58.9941'
                    y1='58.136'
                    x2='58.9941'
                    y2='70.3077'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#FFCC00' />
                    <stop offset='1' stopColor='#0088B2' />
                </linearGradient>
                <linearGradient
                    id='paint18_linear_10736_46760'
                    x1='58.9934'
                    y1='61.3268'
                    x2='58.9934'
                    y2='66.304'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#FFCC00' />
                    <stop offset='1' stopColor='#0088B2' />
                </linearGradient>
                <linearGradient
                    id='paint19_linear_10736_46760'
                    x1='6.5118'
                    y1='61.9075'
                    x2='6.5118'
                    y2='72.6349'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#FFCC00' />
                    <stop offset='1' stopColor='#0088B2' />
                </linearGradient>
                <linearGradient
                    id='paint20_linear_10736_46760'
                    x1='2.4475'
                    y1='62.9846'
                    x2='2.4475'
                    y2='75.5266'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#FFCC00' />
                    <stop offset='1' stopColor='#0088B2' />
                </linearGradient>
                <linearGradient
                    id='paint21_linear_10736_46760'
                    x1='13.0429'
                    y1='62.4347'
                    x2='13.0429'
                    y2='68.4279'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#FFCC00' />
                    <stop offset='1' stopColor='#0088B2' />
                </linearGradient>
                <clipPath id='clip0_10736_46760'>
                    <rect
                        width='141.788'
                        height='98'
                        fill='white'
                        transform='translate(0.212646)'
                    />
                </clipPath>
                <clipPath id='clip1_10736_46760'>
                    <rect
                        width='52.0682'
                        height='11.7337'
                        fill='white'
                        transform='translate(20.6335 60.2886)'
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export default TreasurySplashScreenImage;

export const LinkIcon = () => {
    return (
        <svg
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M3.27 12C2.48 11.05 2 9.83 2 8.5C2 5.48 4.47 3 7.5 3H12.5C15.52 3 18 5.48 18 8.5C18 11.52 15.53 14 12.5 14H10'
                stroke='#0088B2'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M20.73 12C21.52 12.95 22 14.17 22 15.5C22 18.52 19.53 21 16.5 21H11.5C8.48 21 6 18.52 6 15.5C6 12.48 8.47 10 11.5 10H14'
                stroke='#0088B2'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
};

export const SecureIcon = () => {
    return (
        <svg
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M10.4899 2.23L5.49991 4.11C4.34991 4.54 3.40991 5.9 3.40991 7.12V14.55C3.40991 15.73 4.18991 17.28 5.13991 17.99L9.43991 21.2C10.8499 22.26 13.1699 22.26 14.5799 21.2L18.8799 17.99C19.8299 17.28 20.6099 15.73 20.6099 14.55V7.12C20.6099 5.89 19.6699 4.53 18.5199 4.1L13.5299 2.23C12.6799 1.92 11.3199 1.92 10.4899 2.23Z'
                stroke='#0088B2'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M9.05005 11.87L10.66 13.48L14.96 9.17999'
                stroke='#0088B2'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
};

export const BalancesIcon = () => {
    return (
        <svg
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M21 7V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V7C3 4 4.5 2 8 2H16C19.5 2 21 4 21 7Z'
                stroke='#0088B2'
                strokeWidth='1.5'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M14.5 4.5V6.5C14.5 7.6 15.4 8.5 16.5 8.5H18.5'
                stroke='#0088B2'
                strokeWidth='1.5'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M8 13H12'
                stroke='#0088B2'
                strokeWidth='1.5'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M8 17H16'
                stroke='#0088B2'
                strokeWidth='1.5'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
};

export const CashFlow = () => {
    return (
        <svg
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M16.5 9.5L12.3 13.7L10.7 11.3L7.5 14.5'
                stroke='#0088B2'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M14.5 9.5H16.5V11.5'
                stroke='#0088B2'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z'
                stroke='#0088B2'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
};

export const GrowthIcon = () => {
    return (
        <svg
            width='24'
            height='25'
            viewBox='0 0 24 25'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M9.02 3.34016L3.63 7.54016C2.73 8.24016 2 9.73016 2 10.8602V18.2702C2 20.5902 3.89 22.4902 6.21 22.4902H17.79C20.11 22.4902 22 20.5902 22 18.2802V11.0002C22 9.79016 21.19 8.24016 20.2 7.55016L14.02 3.22016C12.62 2.24016 10.37 2.29016 9.02 3.34016Z'
                stroke='#0088B2'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M16.5 12L12.3 16.2L10.7 13.8L7.5 17'
                stroke='#0088B2'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M14.5 12H16.5V14'
                stroke='#0088B2'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
};

export const ARMIcon = () => {
    return (
        <svg
            width='76'
            height='76'
            viewBox='0 0 76 76'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            xmlnsXlink='http://www.w3.org/1999/xlink'
        >
            <rect width='76' height='76' fill='url(#pattern0_11000_202763)' />
            <defs>
                <pattern
                    id='pattern0_11000_202763'
                    patternContentUnits='objectBoundingBox'
                    width='1'
                    height='1'
                >
                    <use
                        xlinkHref='#image0_11000_202763'
                        transform='scale(0.00444444)'
                    />
                </pattern>
                <image
                    id='image0_11000_202763'
                    width='225'
                    height='225'
                    preserveAspectRatio='none'
                    xlinkHref='data:image/png;base64,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'
                />
            </defs>
        </svg>
    );
};
